import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'

import styles from './ChipsGroup.module.scss'

export const ChipsGroup = ({ chips, className = undefined }) => (
  <Box
    className={cx(styles.chips, { [className]: Boolean(className) })}
    tagName="span"
    shouldWrapContent
  >
    {R.map(
      text => (
        <span className={styles.chip} key={text}>
          {text}
        </span>
      ),
      chips,
    )}
  </Box>
)
